import { cn } from '@/utils/cn';

const COLUMNS = {
  1: '',
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-2 lg:grid-cols-3',
};

/** A definition list of record fields, evenly spaced. */
export function FactList({ children, columns = 2, className }) {
  return <dl className={cn('grid gap-x-6 gap-y-4', COLUMNS[columns], className)}>{children}</dl>;
}

/**
 * One field.
 *
 * An absent value renders nothing at all rather than a dash: on a profile
 * somebody has half filled in, a column of "—" reads as broken rather than
 * incomplete. Pass `showEmpty` where the absence is itself the answer.
 */
export function Fact({ label, value, children, href, showEmpty = false }) {
  const body = children ?? value;
  const empty = body == null || body === '';
  if (empty && !showEmpty) return null;

  return (
    <div className="min-w-0">
      <dt className="text-ink-muted text-xs">{label}</dt>
      <dd className="text-ink mt-0.5 text-sm break-words">
        {empty ? (
          <span className="text-ink-muted">—</span>
        ) : href ? (
          <a
            href={href}
            target="_blank"
            rel="noreferrer noopener"
            className="text-brand-700 hover:underline"
          >
            {body}
          </a>
        ) : (
          body
        )}
      </dd>
    </div>
  );
}

/** A block of prose from a record: a description, requirements, a bio. */
export function Prose({ title, children }) {
  if (!children) return null;
  return (
    <section className="mt-5">
      {title && <h3 className="text-ink text-sm font-semibold">{title}</h3>}
      <p className="text-ink-muted mt-1 text-sm leading-relaxed whitespace-pre-line">{children}</p>
    </section>
  );
}
